import { ApiResponse, getData, postJson } from "./Apis";

export type AccountSecurityFeaturesModel = {
    MFA_App: boolean,
    MFA_Sms: boolean,
}

export type MfaStateModel = {
    Type: MfaTypeModel,
    Enabled: boolean,
    CanBeRemoved: boolean,
    UserMFAVerified: boolean,
}

export type AccountSecurityModel = {
    Features: AccountSecurityFeaturesModel,
    MfaStates: MfaStateModel[],
    HasAcceptedPhoneNumber: boolean,
}

export type MfaTypeModel = {
    Name: string,
    Type: string,
}

export type SetupTypeResponseModel = {
    Message: string,
    Completed: boolean,
    Secret: string,
    ImageUrl: string,
}

export type AccountSecuritySetupCodeResponseModel = {
    Type: string,
    Code: string,
}

export async function API_AccountSecurityStatus(): Promise<ApiResponse<AccountSecurityModel>> {
    return await getData<ApiResponse<AccountSecurityModel>>("webapi/candidate/AccountSecurity/GetStatus");
}

export async function API_AccountSecurityGenerateCode(data: AccountSecuritySetupCodeResponseModel): Promise<ApiResponse<SetupTypeResponseModel>> {
    return await postJson<ApiResponse<SetupTypeResponseModel>>("webapi/candidate/AccountSecurity/GenerateCode", data);
}

export async function API_AccountSecurityVerifyMfaType(data: AccountSecuritySetupCodeResponseModel): Promise<ApiResponse<SetupTypeResponseModel>> {
    return await postJson<ApiResponse<SetupTypeResponseModel>>("webapi/candidate/AccountSecurity/VerifyMfaType", data);
}

export async function API_AccountSecurityRemoveMfaType(data: AccountSecuritySetupCodeResponseModel): Promise<ApiResponse<SetupTypeResponseModel>> {
    return await postJson<ApiResponse<SetupTypeResponseModel>>("webapi/candidate/AccountSecurity/RemoveMfaType", data);
}
